import React from "react";

export default function MagnifyingGlassIcon(props: any) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.2642 13.7342L11.0529 10.5229C11.9687 9.46984 12.4398 8.10233 12.3669 6.70867C12.294 5.31501 11.6829 4.00409 10.6623 3.05225C9.64171 2.1004 8.29143 1.58198 6.89608 1.60629C5.50073 1.63059 4.16933 2.19571 3.18252 3.18252C2.19571 4.16933 1.63059 5.50073 1.60629 6.89608C1.58198 8.29143 2.1004 9.64171 3.05225 10.6623C4.00409 11.6829 5.31501 12.294 6.70867 12.3669C8.10233 12.4398 9.46984 11.9687 10.5229 11.0529L13.7342 14.2642C13.8053 14.3304 13.8993 14.3665 13.9965 14.3648C14.0936 14.3631 14.1863 14.3237 14.255 14.255C14.3237 14.1863 14.3631 14.0936 14.3648 13.9965C14.3665 13.8993 14.3304 13.8053 14.2642 13.7342ZM2.37419 6.99919C2.37419 6.08445 2.64544 5.19025 3.15364 4.42968C3.66184 3.6691 4.38417 3.0763 5.22928 2.72625C6.07439 2.37619 7.00432 2.2846 7.90148 2.46306C8.79865 2.64151 9.62274 3.082 10.2696 3.72882C10.9164 4.37564 11.3569 5.19973 11.5353 6.0969C11.7138 6.99406 11.6222 7.92399 11.2721 8.7691C10.9221 9.61421 10.3293 10.3365 9.5687 10.8447C8.80813 11.3529 7.91393 11.6242 6.99919 11.6242C5.77302 11.6227 4.5975 11.1349 3.73046 10.2679C2.86343 9.40088 2.37568 8.22536 2.37419 6.99919Z"
        fill="#A8A8A8"
      />
    </svg>
  );
}
